(function () {
  function setLegendValue(fieldset, input) {
    if (!fieldset || !input) return;
    const legendValue = fieldset.querySelector('.js-color-text');
    if (!legendValue) return;

    const labelNode = fieldset.querySelector('label[for="' + input.id + '"] .js-value');
    const text = (labelNode ? labelNode.textContent : input.value || '').trim();
    if (text) legendValue.textContent = text;
  }

  function updateAll(container) {
    (container.querySelectorAll('fieldset.option-selector[data-selector-type="listed"]') || []).forEach(function (fs) {
      const checked = fs.querySelector('input[type="radio"].js-option:checked');
      if (checked) setLegendValue(fs, checked);
    });
  }

  // Initialize on ready
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('variant-picker') || document;
    updateAll(root);
  });

  // Update when a radio changes
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('input[type="radio"].js-option')) return;
    const fs = e.target.closest('fieldset.option-selector[data-selector-type="listed"]');
    setLegendValue(fs, e.target);
  });

  // Also listen for theme events (Dawn & similar emit this)
  document.addEventListener('variant:change', function () {
    const root = document.querySelector('variant-picker') || document;
    updateAll(root);
  });
})();